module.exports = __webpack_public_path__ + "static/wittgensteins-vienna-92998adf0f88c98a6826862b54b5efe2.jpg";